import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuantityType } from '@fintronners/internal-core/src/trade/constants';
import CarouselToggler, {
  CarouselTogglerProps,
} from '@/components/common/CarouselToggler/CarouselToggler';

export type QuantityTypeTogglerProps = Omit<CarouselTogglerProps<QuantityType>, 'options'>;

export const QuantityTypeToggler = (props: QuantityTypeTogglerProps) => {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      {
        id: QuantityType.DOLLARS,
        label: t('common.dollar_plural'),
      },
      {
        id: QuantityType.SHARES,
        label: t('common.share_plural'),
      },
    ],
    [t],
  );

  return <CarouselToggler {...props} options={options} />;
};
